const ProjectStore = {
  projects: [
    {
      id: 0,
      title: 'Cellarmaster Wines',
      role: 'Freelance Project',
      date: 'October 2021',
      tech: 'Shopify & Liquid, JavaScript, CSS',
      descriptionShort: `This freelance project was to rebuild an ecommerce for create a clearer brand identity and drive sales.`,
      descriptionLong: `As a freelance software developer, I worked on an ecommerce project that involved redesigning the entire ecommerce store for a client. The client had an existing store that was outdated and not meeting their business needs. They wanted a new Shopify store that was modern, user-friendly, and could better showcase their products and services. To start the project, I had several meetings with the client to understand their goals, target audience, and design preferences. We discussed their pain points with the existing store and what they wanted to achieve with the rebrand. Based on this information, I created a detailed project plan and timeline. The first step was to conduct a thorough audit of the existing store to identify areas for improvement. I analyzed the store's design, layout, functionality, and user experience to identify what was working and what was not. Next, I worked on creating a new design that met the client's requirements and aligned with their brand. We discussed various design options and finalized a design that was visually appealing, user-friendly, and showcased their products effectively. Once the design was finalized, I started the development process. I redesigned each custom section to match the approved mockups, and ensured the client could update the content within whenever they needed. Throughout the development process, I provided regular updates to the client and made adjustments based on their feedback. We conducted user testing to ensure that the store was easy to use and navigate. Once the store was complete, I trained the client on how to manage and update the store themselves. I also provided ongoing support to ensure that the store continued to run smoothly and met their business goals. Overall, this was a challenging but rewarding project that involved working closely with the client to create a Shopify store that exceeded their expectations. The new store is now modern, user-friendly, and helps the client showcase their products more effectively, which has led to an increase in sales and business growth.`,
      imageName: 'gif/cellarmaster-demo.gif',
      route: 'cellarmaster',
      readMore: true,
      visitSite: true,
      siteURL: 'https://cellarmasterwines.com/',
      visible: true,
    }, 
    {
      id: 1,
      title: 'Fencify',
      role: 'Freelance Project',
      date: 'August 2022',
      tech: 'Next.js, SCSS, SendGrid',
      descriptionShort: `This freelance project was to build a focused website for a client, so they could drive more customers to one of their services.`,
      descriptionLong: `This project was a freelance project built with JavaScript/React.js/Next.js, HTML/SCSS, SendGrid, and hosted on Vercel. The site was built to highlight one of the business' services and drive a more focused set of customers to get a quote for that service. Customers can request a quote via email, which allows them to submit an enquiry via form. The details entered into the form get converted into an email, which is then sent to the business owner.`,
      imageName: 'gif/fencify-demo.gif',
      route: 'fencify',
      readMore: true,
      visitSite: true,
      siteURL: 'https://fencify.vercel.app/',
      visible: true,
    },
    {
      id: 2,
      title: 'Rosewood Construction',
      role: 'Freelance Project',
      date: 'August 2021',
      tech: 'Next.js, Tailwind CSS, Contentful',
      descriptionShort: `This freelance website was to build out a template the client could then populate with their own content to showcase their projects and services.`,
      descriptionLong: `This project was a freelance project built with JavaScript/React.js/Next.js, Tailwind CSS, Contentful, and hosted on Vercel. The site was built to highlight the business' projects, services, and provide a way for customers to get in touch with the company. Customers can easily view the company's services, and specific details about projects they've done in the past. The main purpose behind this site is to showcase the work the company is able to perform, build trust with potential customers, and turn those potential customers into satisfied clients.`,
      imageName: 'gif/rosewood-demo.gif',
      route: 'rosewood',
      readMore: true,
      visitSite: true,
      siteURL: 'https://rosewood.vercel.app/',
      visible: true,
    },
    {
      id: 996,
      title: 'Photo Share',
      role: 'Team Lead',
      date: 'November 2020',
      tech: 'PHP, MySQL, phpMyAdmin',
      descriptionShort: `This project was an academic project to allow users to upload and share photos with their friends.`,
      descriptionLong: `This project was an academic project built with PHP, phpMyAdmin, MySQL, JavaScript, and HTML/CSS. The app enabled users to add, update and delete photo albums and pictures which could then be shared with friends or viewed exclusively by the owner. After signing up for an account, a user is then able to send and receive friend requests to view their friends' albums.`,
      imageName: 'gif/photo-sharing-demo.gif',
      route: 'photo-share',
      readMore: true,
      visitSite: false,
      visible: false,
    },
    {
      id: 997,
      title: 'Oscars Web App',
      role: 'Personal Project',
      date: 'September 7-9th, 2020',
      tech: 'JS, Vue.js, OMDB API, Tailwind CSS ',
      descriptionShort: `The Oscars Web App was personal project built to practice implenting RESTful APIs. The app allowed for users to nominate 5 movies for an Oscar.`,
      descriptionLong: `This project was a web app built with Javascript, Vue.js, Node.js, HTML/CSS, and Tailwind CSS, using the OMDB (Open Movie Database) RESTful API. The app enabled users to perform a search for a movie title on the site which will return a list of movies with the corresponding searched for name. Users were then able to nominate (and un-nominate) their favorite movies for an Oscar.`,
      imageName: 'gif/shoppies-demo.gif',
      route: 'shoppies',
      readMore: true,
      visitSite: true,
      siteURL: 'https://oscars-app.netlify.app/',
      visible: false,
    },
    {
      id: 998,
      title: 'PassMan',
      role: 'Personal Project',
      date: 'July 2020',
      tech: 'JavaScript, Node.js',
      descriptionShort: `PassMan was a simple CLI app that enabled a user to store, retrieve, update and delete encrypted passwords for their respective accounts.`,
      descriptionLong: `This project was a simple CLI app built with Node.js and written in JavaScript. The app enabled a user to store, retrieve, update, and delete accounts and their respective passwords in a local database. The passwords and their accounts were both encrypted within the database for proper safekeeping and decrypted upon retrieval request of the account/password.`,
      imageName: 'gif/passman-demo.gif',
      route: 'passman',
      readMore: true,
      visitSite: false,
      visible: false,
    },
    {
      id: 999,
      title: 'Portfolio Site',
      role: 'Personal Project',
      date: 'August 2020',
      tech: 'JS, Vue.js, HTML/CSS',
      descriptionShort: `This project was my personal portfolio to show the projects I've worked on and demonstrate my skills as a software developer.`,
      descriptionLong: `For this project, I wanted to create a portfolio site that would beautifully demonstrate my work and skills as a software developer. I wanted to build a single page application to keep the aesthetic clean, as well as an app that will scale with me over time. As the number of projects and their complexities increase, I wanted a site that would be easily updatable and maintainable. My main emphasis for this project was to allow visitors to see my work and contact me easily.`,
      imageName: 'gif/portfolio-demo.gif',
      route: 'portfolio',
      readMore: true,
      visitSite: false,
      visible: false,
    }
  ],
}

export default ProjectStore
